import React, { useEffect } from 'react';
import './ConfirmDialog.css';
import { FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';

export default function ConfirmDialog({
  open,
  title = 'Confirmación',
  message,
  confirmLabel = 'Aceptar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  tone = 'default', // 'default' | 'warning' | 'danger' | 'success'
  confirmDisabled = false,
  showCancel = true,
  icon,
  theme = 'dark', // 'dark' | 'light' | 'beige'
}) {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === 'Escape') {
        onCancel && onCancel();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onCancel]);

  if (!open) return null;

  const ResolvedIcon = icon || (tone === 'success' ? FaCheckCircle : FaExclamationCircle);

  if (theme === 'premium') {
    return (
      <div className="confirm-premium-overlay" role="dialog" aria-modal="true">
        <div className={`confirm-premium-modal ${tone}`}>
          <div className="confirm-premium-content">
            <div className="confirm-premium-header">
              <div className="confirm-premium-icon-box">
                <ResolvedIcon aria-hidden="true" />
              </div>
              <h4>{title}</h4>
            </div>
            <div className="confirm-premium-body">
              <p>{message}</p>
            </div>
            <div className="confirm-premium-actions">
              {showCancel && (
                <button
                  type="button"
                  className="confirm-btn-premium secondary"
                  onClick={onCancel}
                >
                  {cancelLabel}
                </button>
              )}
              <button
                type="button"
                className={`confirm-btn-premium primary ${tone}`}
                onClick={onConfirm}
                disabled={confirmDisabled}
              >
                {confirmLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (theme === 'light') {
    return (
      <div className="confirm-dialog-backdrop" role="dialog" aria-modal="true">
        <div className="confirm-dialog">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <ResolvedIcon aria-hidden="true" style={{ color: tone === 'danger' ? '#ef4444' : '#0f172a' }} />
            <h4>{title}</h4>
          </div>
          <p>{message}</p>
          <div className="confirm-dialog-actions">
            {showCancel && (
              <button type="button" className="confirm-dialog-button" onClick={onCancel}>
                {cancelLabel}
              </button>
            )}
            <button
              type="button"
              className={`confirm-dialog-button ${tone === 'danger' ? 'danger' : 'primary'}`}
              onClick={onConfirm}
              disabled={confirmDisabled}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="confirm-overlay" role="dialog" aria-modal="true">
      <div className={`confirm-modal ${tone}`}>
        <div className="confirm-header">
          <ResolvedIcon aria-hidden="true" />
          <h4>{title}</h4>
        </div>
        <div className="confirm-body">
          <p>{message}</p>
        </div>
        <div className="confirm-actions">
          {showCancel && (
            <button type="button" className="btn-secondary" onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
          <button type="button" className="btn-primary" onClick={onConfirm} disabled={confirmDisabled}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
